<template>
    <div class="ah-select-accounting-setting" :class="{ center: align === 'center' }" :style="{ width }">
        <el-cascader
            v-model="cascaderVal"
            no-data-text="無資料"
            no-match-text="無相關資料"
            placeholder="請選擇"
            :options="settings"
            :show-all-levels="false"
            :props="{
                expandTrigger: 'hover'
            }"
            filterable
            :filter-method="filterMethod"
            :clearable="clearable"
            @change="onCascaderChange"
            @keydown.native.capture.enter="preventIMESelect"
            :size="size"
            ref="input"
        >
        </el-cascader>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    name: 'ah-select-accounting-setting',
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'normal',
        },
        queryType: {
            type: Number,
            default: null,
        },
        allowedGroups: {
            type: Array,
            default: null,
        },
        allowedItems: {
            type: Array,
            default: null,
        },
        align: {
            type: String,
            default: 'left',
        },
        useSno: Boolean,
        clearable: Boolean,
        width: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            cascaderVal: [null],

            tempValue: null,
        };
    },
    watch: {
        value(val) {
            this.cascaderVal = this.getHierarchyArrayFromLeafValue(val);
        },
    },
    computed: {
        settings() {
            let allOption = this.$store.getters['accounting/settingsForSelect'];

            if (this.allowedGroups?.length) allOption = _.filter(allOption, (o) => this.allowedGroups.includes(o.value));

            if (this.allowedItems?.length) {
                const list = [];
                allOption.forEach((item) => {
                    list.push({ ...item, children: _.filter(item.children, (o) => this.allowedItems.includes(o.accno.split('-')[0])) });
                });
                allOption = list;
            }

            if (this.queryType) this.onCheck();

            if (!this.queryType || this.queryType === 1) return allOption;

            const newOptions = [];
            allOption.forEach((item) => {
                newOptions.push({ ...item, children: _.filter(item.children, (o) => !o.accno.includes('-')) });
            });

            return newOptions;
        },
    },
    mounted() {
        if (this.value) {
            const wait = this.settings !== null ? 1 : 1500;
            setTimeout(() => {
                this.cascaderVal = this.getHierarchyArrayFromLeafValue(this.value);
            }, wait);
        }
    },
    methods: {
        onCheck() {
            const CURRENT_ACCONO = _.last(this.cascaderVal);

            if (this.queryType === 1) {
                if (this.tempValue) {
                    this.cascaderVal[1] = this.tempValue;
                    this.tempValue = null;
                    this.$nextTick(() => {
                        this.onCascaderChange();
                    });
                }
            } else if (CURRENT_ACCONO?.includes('-')) {
                if (!this.tempValue) this.tempValue = _.last(this.cascaderVal);
                this.cascaderVal[1] = _.head(CURRENT_ACCONO?.split('-'));
                this.$nextTick(() => {
                    this.onCascaderChange();
                });
            }
        },
        onCascaderChange(event) {
            // 回傳最後一個值
            const val = this.cascaderVal[this.cascaderVal.length - 1];
            const item = this.getItemByAccno(val);

            if (val !== 0 && val !== null) {
                this.$emit('input', this.useSno ? item.sno : val);
            } else {
                this.$emit('input', null);
            }

            this.$emit('change', { ...item });
            if (event && !event[1]?.includes('-')) this.tempValue = null;
        },
        getItemByAccno(accno) {
            const allSettings = this.settings;
            for (let i = 0; i < allSettings.length; i += 1) {
                const group = allSettings[i];
                for (let j = 0; j < group.children.length; j += 1) {
                    const item = group.children[j];
                    if (item.value === accno) {
                        return item;
                    }
                }
            }
            return null;
        },
        getHierarchyArrayFromLeafValue(v) {
            if (v === null) {
                return [null];
            }
            const allSettings = this.settings;
            for (let i = 0; i < allSettings.length; i += 1) {
                const group = allSettings[i];
                for (let j = 0; j < group.children.length; j += 1) {
                    const item = group.children[j];
                    const COMPARE = this.useSno ? item.sno : item.value;
                    if (COMPARE === v) {
                        return [group.value, item.value];
                    }
                }
            }
            return [null];
        },
        focus() {
            this.$refs.input.$refs.input.focus();
        },

        filterMethod(node, keyword) {
            // 如果首字是數字，則使用從頭比對的方式
            // 如果非數字（一般文字），則使用全文搜尋方式
            if (this.isCharNumber(keyword[0])) {
                const REG = new RegExp(`^${keyword}`);
                return !!node.value.match(REG);
            }
            const REG = new RegExp(`${keyword}`);
            return !!node.text.match(REG);
        },
        isCharNumber(c) {
            return c >= '0' && c <= '9';
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
.ah-select-accounting-setting {
    display: block;

    .el-cascader {
        display: block;
    }
    .el-input {
        min-width: 200px;
        width: 100%;
    }

    .el-input > input {
        cursor: text;
    }

    &.center {
        .el-input > input {
            text-align: center;
        }
    }
}

.el-select-dropdown__item.accounting-setting-item {
}
</style>
